import { baseObjectSchema } from '../baseSchemas';
import { z } from 'zod';

export const rangeCustomerTradersite = baseObjectSchema.extend({
  rangeId: z.string().optional(),
  traderSiteId: z.string(),
  customerId: z.string(),
  hasDynamicRange: z.boolean(),
  traderSite: z
    .object({
      id: z.string(),
      name: z.string(),
      code: z.string(),
    })
    .optional(),
  customer: z
    .object({
      code: z.string(),
      id: z.string(),
    })
    .optional(),
  range: z
    .object({
      id: z.string(),
      name: z.string(),
      code: z.string(),
    })
    .optional(),
});

export const getRangeCustomerTradersitesSchema = z.array(rangeCustomerTradersite);

export type GetRangeCustomerTradersitesResponse = z.infer<typeof getRangeCustomerTradersitesSchema>;
